import type { IconSvgObject } from './types';

const EggIcon: IconSvgObject = [
  ["path", { d: "M12 22C16.4183 22 20 19 20 14C20 9 16.4183 2 12 2C7.58172 2 4 9 4 14C4 19 7.58172 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default EggIcon;
